/*
 * General custom scripts
 */
import { initHeaderLanding } from './front/header-landing';

initHeaderLanding();
